// import { useState, useEffect } from "react";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { useMutation } from "@tanstack/react-query";
// import { toast } from "react-toastify";
// import { useForm, Controller } from "react-hook-form";
// import ReactQuill from "react-quill";
// import Label from "../../ChildComponents/Label";
// import Input from "../../ChildComponents/Input";
// import BrandButton from "../../ChildComponents/BrandButton";
// import SmartImageUpload from "../../ChildComponents/SmartImageUploader";
// import { Rolechema } from "../validation/roleValidation";
// import { useCreateInfo } from "../../store/api/generalSettingApi";

// function Form({ data, editId, onSuccessCreated }) {
//   const createInfo = useCreateInfo(editId?._id);

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     reset,
//     control,
//   } = useForm({
//     resolver: yupResolver(Rolechema),
//   });

//   useEffect(() => {
//     if (editId) {
//       reset({
//         websiteName: editId.websiteName || "",
//         tagLine: editId.tagLine || "",
//         phone: editId.phone || "",
//         mobile: editId.mobile || "",
//         email: editId.email || "",
//         address: editId.address || "",
//         facebook: editId.facebook || "",
//         youtube: editId.youtube || "",
//         whatsapps: editId.whatsapps || "",
//         twitter: editId.twitterX || "",
//         instagram: editId.instagram || "",
//         linkedIn: editId.linkedIn || "",
//         googleNews: editId.googleNews || "",
//         playStore: editId.playStore || "",
//         appsStore: editId.appsStore || "",
//         websiteTitle: editId.websiteTitle || "",
//         discription: editId.metaDescription || "",
//         image: editId.logo ? `${editId.logo}` : null,
//       });
//       setEdited(true);
//     } else {
//       reset({
//         websiteName: "",
//         tagLine: "",
//         phone: "",
//         mobile: "",
//         email: "",
//         address: "",
//         facebook: "",
//         youtube: "",
//         whatsapps: "",
//         twitter: "",
//         instagram: "",
//         linkedIn: "",
//         googleNews: "",
//         playStore: "",
//         appsStore: "",
//         websiteTitle: "",
//         discription: "",
//         image: null,
//       });
//       setEdited(false);
//     }
//   }, [editId, reset]);

//   const [loading, setLoading] = useState(false);
//   const [edited, setEdited] = useState(editId ? true : false);

//   const mutation = useMutation({
//     mutationFn: (data) => {
//       return createInfo(data);
//     },
//     onSuccess: (data) => {
//       setLoading(false);
//       toast.success("Created Successfully");
//       reset();
//       onSuccessCreated(1);
//     },
//     onError: (error) => {
//       toast.error(error.message);
//       setLoading(false);
//     },
//   });

//   const onSubmit = async (formData) => {
//     setLoading(true);
//     try {
//       const data = new FormData();
//       if (!formData.image) {
//         toast.warning("Logo image is required!");
//         setLoading(false);
//         return;
//       }
//       data.append("websiteName", formData.websiteName);
//       data.append("tagLine", formData.tagLine);
//       data.append("phone", formData.phone);
//       data.append("mobile", formData.mobile);
//       data.append("email", formData.email);
//       data.append("address", formData.address);
//       data.append("facebook", formData.facebook);
//       data.append("youtube", formData.youtube);
//       data.append("whatsapps", formData.whatsapps);
//       data.append("twitterX", formData.twitter);
//       data.append("instagram", formData.instagram);
//       data.append("linkedIn", formData.linkedIn);
//       data.append("googleNews", formData.googleNews);
//       data.append("playStore", formData.playStore);
//       data.append("appsStore", formData.appsStore);
//       data.append("websiteTitle", formData.websiteTitle);
//       data.append("metaDescription", formData.discription);
//       data.append("image", formData.image);

//       mutation.mutate(data);
//     } catch (error) {
//       toast.error("Something went wrong.");
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="modern-settings-container">
//       <style>{`
//         .modern-settings-container {
//           padding: 2rem;
//           background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
//           min-height: 100vh;
//         }

//         .settings-header {
//           background: white;
//           padding: 2rem;
//           border-radius: 20px;
//           margin-bottom: 2rem;
//           box-shadow: 0 2px 20px rgba(0,0,0,0.03);
//           border: 1px solid #e9ecef;
//         }

//         .settings-title {
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//           background-clip: text;
//           font-size: 2rem;
//           font-weight: 800;
//           margin: 0;
//           display: flex;
//           align-items: center;
//           gap: 0.75rem;
//         }

//         .settings-subtitle {
//           color: #718096;
//           margin: 0.5rem 0 0 0;
//           font-size: 1rem;
//         }

//         .section-card {
//           background: white;
//           border-radius: 20px;
//           padding: 2rem;
//           margin-bottom: 1.5rem;
//           box-shadow: 0 2px 20px rgba(0,0,0,0.03);
//           border: 1px solid #e9ecef;
//           transition: all 0.3s ease;
//         }

//         .section-card:hover {
//           box-shadow: 0 8px 30px rgba(102, 126, 234, 0.1);
//           border-color: rgba(102, 126, 234, 0.2);
//         }

//         .section-header {
//           display: flex;
//           align-items: center;
//           gap: 0.75rem;
//           margin-bottom: 1.5rem;
//           padding-bottom: 1rem;
//           border-bottom: 2px solid #f0f0f0;
//         }

//         .section-icon {
//           width: 40px;
//           height: 40px;
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           border-radius: 12px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 1.25rem;
//           color: white;
//           box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
//         }

//         .section-title {
//           font-size: 1.25rem;
//           font-weight: 700;
//           color: #2d3748;
//           margin: 0;
//         }

//         .sidebar-card {
//           position: sticky;
//           top: 2rem;
//           background: white;
//           border-radius: 20px;
//           padding: 1.5rem;
//           box-shadow: 0 2px 20px rgba(0,0,0,0.03);
//           border: 1px solid #e9ecef;
//         }

//         .image-card-header {
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           padding: 1rem 1.5rem;
//           border-radius: 14px;
//           margin-bottom: 1.5rem;
//           box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
//         }

//         .image-card-title {
//           color: white;
//           font-size: 1.125rem;
//           font-weight: 700;
//           margin: 0;
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .save-button-wrapper {
//           position: sticky;
//           bottom: 2rem;
//           background: white;
//           padding: 1.5rem;
//           border-radius: 20px;
//           box-shadow: 0 -4px 20px rgba(0,0,0,0.08);
//           border: 1px solid #e9ecef;
//           margin-top: 2rem;
//           display: flex;
//           gap: 1rem;
//           justify-content: flex-end;
//         }

//         .modern-save-btn {
//           padding: 0.875rem 2.5rem;
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           border: none;
//           border-radius: 14px;
//           color: white;
//           font-weight: 700;
//           font-size: 1rem;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .modern-save-btn:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
//         }

//         .modern-save-btn:disabled {
//           opacity: 0.6;
//           cursor: not-allowed;
//           transform: none;
//         }

//         .quill-wrapper {
//           background: white;
//           border-radius: 14px;
//           overflow: hidden;
//           border: 2px solid #e9ecef;
//           transition: border-color 0.3s ease;
//         }

//         .quill-wrapper:focus-within {
//           border-color: #667eea;
//         }

//         .quill-wrapper .ql-toolbar {
//           background: #f8f9fa;
//           border: none;
//           border-bottom: 2px solid #e9ecef;
//         }

//         .quill-wrapper .ql-container {
//           border: none;
//           min-height: 150px;
//         }

//         @media (max-width: 768px) {
//           .modern-settings-container {
//             padding: 1rem;
//           }

//           .settings-header {
//             padding: 1.5rem;
//           }

//           .settings-title {
//             font-size: 1.5rem;
//           }

//           .section-card {
//             padding: 1.5rem;
//           }

//           .sidebar-card {
//             position: relative;
//             top: 0;
//           }

//           .save-button-wrapper {
//             position: relative;
//             bottom: 0;
//           }
//         }
//       `}</style>

//       {/* Header */}
//       <div className="settings-header">
//         <h1 className="settings-title">⚙️ General Settings</h1>
//         <p className="settings-subtitle">
//           Configure your website's basic information and settings
//         </p>
//       </div>

//       <form onSubmit={handleSubmit(onSubmit)}>
//         <div className="row">
//           {/* Main Content */}
//           <div className="col-lg-9">
//             {/* Website Information */}
//             <div className="section-card">
//               <div className="section-header">
//                 <div className="section-icon">🌐</div>
//                 <h2 className="section-title">Website Information</h2>
//               </div>
//               <div className="row g-3">
//                 <div className="col-md-6">
//                   <Input
//                     icon="title"
//                     {...register("websiteName")}
//                     error={errors.websiteName?.message}
//                     type="text"
//                     placeholder="24 Bangladesh"
//                     label="Website Name"
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <Input
//                     icon="title"
//                     {...register("tagLine")}
//                     error={errors.tagLine?.message}
//                     type="text"
//                     placeholder="Most Popular News Portal"
//                     label="Tag Line"
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* Contact Information */}
//             <div className="section-card">
//               <div className="section-header">
//                 <div className="section-icon">📞</div>
//                 <h2 className="section-title">Contact Information</h2>
//               </div>
//               <div className="row g-3">
//                 <div className="col-md-6">
//                   <Input
//                     icon="title"
//                     {...register("phone")}
//                     error={errors.phone?.message}
//                     type="text"
//                     placeholder="+880 123 456 789"
//                     label="Phone Number"
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <Input
//                     icon="title"
//                     {...register("mobile")}
//                     error={errors.mobile?.message}
//                     type="text"
//                     placeholder="+880 123 456 789"
//                     label="Mobile Number"
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <Input
//                     icon="title"
//                     {...register("email")}
//                     error={errors.email?.message}
//                     type="email"
//                     placeholder="yourmail@yourdomain.com"
//                     label="Email"
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <Input
//                     icon="title"
//                     {...register("address")}
//                     error={errors.address?.message}
//                     type="text"
//                     placeholder="Dhaka, Bangladesh"
//                     label="Address"
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* Social Media */}
//             <div className="section-card">
//               <div className="section-header">
//                 <div className="section-icon">🔗</div>
//                 <h2 className="section-title">Social Media Links</h2>
//               </div>
//               <div className="row g-3">
//                 <div className="col-md-6">
//                   <Input
//                     icon="title"
//                     {...register("facebook")}
//                     error={errors.facebook?.message}
//                     type="text"
//                     placeholder="www.facebook.com"
//                     label="Facebook Page Link"
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <Input
//                     icon="title"
//                     {...register("youtube")}
//                     error={errors.youtube?.message}
//                     type="text"
//                     placeholder="www.youtube.com"
//                     label="Youtube Page Link"
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <Input
//                     icon="title"
//                     {...register("whatsapps")}
//                     error={errors.whatsapps?.message}
//                     type="text"
//                     placeholder="011234567890"
//                     label="WhatsApp Number"
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <Input
//                     icon="title"
//                     {...register("twitter")}
//                     error={errors.twitter?.message}
//                     type="text"
//                     placeholder="www.twitter.com"
//                     label="Twitter Link"
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <Input
//                     icon="title"
//                     {...register("instagram")}
//                     error={errors.instagram?.message}
//                     type="text"
//                     placeholder="www.instagram.com"
//                     label="Instagram Link"
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <Input
//                     icon="title"
//                     {...register("linkedIn")}
//                     error={errors.linkedIn?.message}
//                     type="text"
//                     placeholder="www.linkedin.com"
//                     label="LinkedIn Link"
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <Input
//                     icon="title"
//                     {...register("googleNews")}
//                     error={errors.googleNews?.message}
//                     type="text"
//                     placeholder="www.news.google.com"
//                     label="Google News"
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* Download Links */}
//             <div className="section-card">
//               <div className="section-header">
//                 <div className="section-icon">📱</div>
//                 <h2 className="section-title">App Download Links</h2>
//               </div>
//               <div className="row g-3">
//                 <div className="col-md-6">
//                   <Input
//                     icon="title"
//                     {...register("playStore")}
//                     error={errors.playStore?.message}
//                     type="text"
//                     placeholder="www.play.google.com/"
//                     label="Play Store"
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <Input
//                     icon="title"
//                     {...register("appsStore")}
//                     error={errors.appsStore?.message}
//                     type="text"
//                     placeholder="www.apple.com/app-store/"
//                     label="App Store"
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* SEO Information */}
//             <div className="section-card">
//               <div className="section-header">
//                 <div className="section-icon">🔍</div>
//                 <h2 className="section-title">SEO Information</h2>
//               </div>
//               <div className="row g-3">
//                 <div className="col-md-12">
//                   <Input
//                     icon="title"
//                     {...register("websiteTitle")}
//                     error={errors.websiteTitle?.message}
//                     type="text"
//                     placeholder="Website Title"
//                     label="Website Title"
//                   />
//                 </div>
//                 <div className="col-md-12">
//                   <Label label="Meta Description" />
//                   <div className="quill-wrapper">
//                     <Controller
//                       name="discription"
//                       control={control}
//                       defaultValue=""
//                       render={({ field }) => (
//                         <ReactQuill
//                           {...field}
//                           theme="snow"
//                           onChange={(content) => field.onChange(content)}
//                         />
//                       )}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Save Button */}
//             <div className="save-button-wrapper">
//               <button
//                 type="submit"
//                 className="modern-save-btn"
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <>
//                     <span
//                       className="spinner-border spinner-border-sm"
//                       role="status"
//                       aria-hidden="true"
//                     ></span>
//                     Saving...
//                   </>
//                 ) : (
//                   <>💾 Save Changes</>
//                 )}
//               </button>
//             </div>
//           </div>

//           {/* Sidebar */}
//           <div className="col-lg-3">
//             <div className="sidebar-card">
//               <div className="image-card-header">
//                 <h5 className="image-card-title">🖼️ Website Logo</h5>
//               </div>
//               <Controller
//                 name="image"
//                 control={control}
//                 defaultValue={null}
//                 render={({ field }) => (
//                   <SmartImageUpload
//                     multiple={false}
//                     limit={1}
//                     files={field.value ? [field.value] : []}
//                     onSelectFiles={(url) => {
//                       field.onChange(url.data[0].image || "");
//                     }}
//                   />
//                 )}
//               />
//             </div>
//           </div>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default Form;

import { useState, useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css"; // ✅ Add this import

import Label from "../../ChildComponents/Label";
import Input from "../../ChildComponents/Input";
import BrandButton from "../../ChildComponents/BrandButton";
import SmartImageUpload from "../../ChildComponents/SmartImageUploader";
import { Rolechema } from "../validation/roleValidation";
import { useCreateInfo } from "../../store/api/generalSettingApi";

function Form({ data, editId, onSuccessCreated }) {
  const createInfo = useCreateInfo(editId?._id);

  // ✅ Quill setup
  const { quill, quillRef } = useQuill({
    modules: {
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
        ["clean"],
      ],
    },
  });

  const [loading, setLoading] = useState(false);
  const [edited, setEdited] = useState(editId ? true : false);
  const [metaDescription, setMetaDescription] = useState(""); // ✅ State for editor content

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
  } = useForm({
    resolver: yupResolver(Rolechema),
  });

  // ✅ Handle Quill text changes
  useEffect(() => {
    if (quill) {
      quill.on("text-change", () => {
        const content = quill.root.innerHTML;
        setMetaDescription(content);
        setValue("discription", content);
      });
    }
  }, [quill, setValue]);

  // ✅ Load initial data
  useEffect(() => {
    if (editId) {
      reset({
        websiteName: editId.websiteName || "",
        tagLine: editId.tagLine || "",
        phone: editId.phone || "",
        mobile: editId.mobile || "",
        email: editId.email || "",
        address: editId.address || "",
        facebook: editId.facebook || "",
        youtube: editId.youtube || "",
        whatsapps: editId.whatsapps || "",
        twitter: editId.twitterX || "",
        instagram: editId.instagram || "",
        linkedIn: editId.linkedIn || "",
        googleNews: editId.googleNews || "",
        playStore: editId.playStore || "",
        appsStore: editId.appsStore || "",
        websiteTitle: editId.websiteTitle || "",
        discription: editId.metaDescription || "",
        image: editId.logo ? `${editId.logo}` : null,
      });

      // ✅ Load content in Quill
      if (quill && editId.metaDescription) {
        quill.clipboard.dangerouslyPasteHTML(editId.metaDescription);
      }

      setEdited(true);
    } else {
      reset({
        websiteName: "",
        tagLine: "",
        phone: "",
        mobile: "",
        email: "",
        address: "",
        facebook: "",
        youtube: "",
        whatsapps: "",
        twitter: "",
        instagram: "",
        linkedIn: "",
        googleNews: "",
        playStore: "",
        appsStore: "",
        websiteTitle: "",
        discription: "",
        image: null,
      });

      // ✅ Clear Quill
      if (quill) {
        quill.setText("");
      }

      setEdited(false);
    }
  }, [editId, reset, quill]);

  const mutation = useMutation({
    mutationFn: (data) => {
      return createInfo(data);
    },
    onSuccess: (data) => {
      setLoading(false);
      toast.success("Created Successfully");
      reset();

      // ✅ Clear Quill after success
      if (quill) {
        quill.setText("");
      }

      onSuccessCreated(1);
    },
    onError: (error) => {
      toast.error(error.message);
      setLoading(false);
    },
  });

  const onSubmit = async (formData) => {
    setLoading(true);
    try {
      const data = new FormData();
      if (!formData.image) {
        toast.warning("Logo image is required!");
        setLoading(false);
        return;
      }
      data.append("websiteName", formData.websiteName);
      data.append("tagLine", formData.tagLine);
      data.append("phone", formData.phone);
      data.append("mobile", formData.mobile);
      data.append("email", formData.email);
      data.append("address", formData.address);
      data.append("facebook", formData.facebook);
      data.append("youtube", formData.youtube);
      data.append("whatsapps", formData.whatsapps);
      data.append("twitterX", formData.twitter);
      data.append("instagram", formData.instagram);
      data.append("linkedIn", formData.linkedIn);
      data.append("googleNews", formData.googleNews);
      data.append("playStore", formData.playStore);
      data.append("appsStore", formData.appsStore);
      data.append("websiteTitle", formData.websiteTitle);
      data.append("metaDescription", metaDescription || formData.discription); // ✅ Use editor content
      data.append("image", formData.image);

      mutation.mutate(data);
    } catch (error) {
      toast.error("Something went wrong.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modern-settings-container">
      <style>{`
        .modern-settings-container {
          padding: 2rem;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          min-height: 100vh;
        }

        .settings-header {
          background: white;
          padding: 2rem;
          border-radius: 20px;
          margin-bottom: 2rem;
          box-shadow: 0 2px 20px rgba(0,0,0,0.03);
          border: 1px solid #e9ecef;
        }

        .settings-title {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-size: 2rem;
          font-weight: 800;
          margin: 0;
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .settings-subtitle {
          color: #718096;
          margin: 0.5rem 0 0 0;
          font-size: 1rem;
        }

        .section-card {
          background: white;
          border-radius: 20px;
          padding: 2rem;
          margin-bottom: 1.5rem;
          box-shadow: 0 2px 20px rgba(0,0,0,0.03);
          border: 1px solid #e9ecef;
          transition: all 0.3s ease;
        }

        .section-card:hover {
          box-shadow: 0 8px 30px rgba(102, 126, 234, 0.1);
          border-color: rgba(102, 126, 234, 0.2);
        }

        .section-header {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 2px solid #f0f0f0;
        }

        .section-icon {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.25rem;
          color: white;
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
        }

        .section-title {
          font-size: 1.25rem;
          font-weight: 700;
          color: #2d3748;
          margin: 0;
        }

        .sidebar-card {
          position: sticky;
          top: 2rem;
          background: white;
          border-radius: 20px;
          padding: 1.5rem;
          box-shadow: 0 2px 20px rgba(0,0,0,0.03);
          border: 1px solid #e9ecef;
        }

        .image-card-header {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          padding: 1rem 1.5rem;
          border-radius: 14px;
          margin-bottom: 1.5rem;
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
        }

        .image-card-title {
          color: white;
          font-size: 1.125rem;
          font-weight: 700;
          margin: 0;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .save-button-wrapper {
          position: sticky;
          bottom: 2rem;
          background: white;
          padding: 1.5rem;
          border-radius: 20px;
          box-shadow: 0 -4px 20px rgba(0,0,0,0.08);
          border: 1px solid #e9ecef;
          margin-top: 2rem;
          display: flex;
          gap: 1rem;
          justify-content: flex-end;
        }

        .modern-save-btn {
          padding: 0.875rem 2.5rem;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          border-radius: 14px;
          color: white;
          font-weight: 700;
          font-size: 1rem;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .modern-save-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
        }

        .modern-save-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .quill-wrapper {
          background: white;
          border-radius: 14px;
          overflow: hidden;
          border: 2px solid #e9ecef;
          transition: border-color 0.3s ease;
        }

        .quill-wrapper:focus-within {
          border-color: #667eea;
        }

        .quill-wrapper .ql-toolbar {
          background: #f8f9fa;
          border: none;
          border-bottom: 2px solid #e9ecef;
        }

        .quill-wrapper .ql-container {
          border: none;
          min-height: 150px;
        }

        @media (max-width: 768px) {
          .modern-settings-container {
            padding: 1rem;
          }

          .settings-header {
            padding: 1.5rem;
          }

          .settings-title {
            font-size: 1.5rem;
          }

          .section-card {
            padding: 1.5rem;
          }

          .sidebar-card {
            position: relative;
            top: 0;
          }

          .save-button-wrapper {
            position: relative;
            bottom: 0;
          }
        }
      `}</style>

      {/* Header */}
      <div className="settings-header">
        <h1 className="settings-title">⚙️ General Settings</h1>
        <p className="settings-subtitle">
          Configure your website's basic information and settings
        </p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          {/* Main Content */}
          <div className="col-lg-9">
            {/* Website Information */}
            <div className="section-card">
              <div className="section-header">
                <div className="section-icon">🌐</div>
                <h2 className="section-title">Website Information</h2>
              </div>
              <div className="row g-3">
                <div className="col-md-6">
                  <Input
                    icon="title"
                    {...register("websiteName")}
                    error={errors.websiteName?.message}
                    type="text"
                    placeholder="24 Bangladesh"
                    label="Website Name"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    icon="title"
                    {...register("tagLine")}
                    error={errors.tagLine?.message}
                    type="text"
                    placeholder="Most Popular News Portal"
                    label="Tag Line"
                  />
                </div>
              </div>
            </div>

            {/* Contact Information */}
            <div className="section-card">
              <div className="section-header">
                <div className="section-icon">📞</div>
                <h2 className="section-title">Contact Information</h2>
              </div>
              <div className="row g-3">
                <div className="col-md-6">
                  <Input
                    icon="title"
                    {...register("phone")}
                    error={errors.phone?.message}
                    type="text"
                    placeholder="+880 123 456 789"
                    label="Phone Number"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    icon="title"
                    {...register("mobile")}
                    error={errors.mobile?.message}
                    type="text"
                    placeholder="+880 123 456 789"
                    label="Mobile Number"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    icon="title"
                    {...register("email")}
                    error={errors.email?.message}
                    type="email"
                    placeholder="yourmail@yourdomain.com"
                    label="Email"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    icon="title"
                    {...register("address")}
                    error={errors.address?.message}
                    type="text"
                    placeholder="Dhaka, Bangladesh"
                    label="Address"
                  />
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div className="section-card">
              <div className="section-header">
                <div className="section-icon">🔗</div>
                <h2 className="section-title">Social Media Links</h2>
              </div>
              <div className="row g-3">
                <div className="col-md-6">
                  <Input
                    icon="title"
                    {...register("facebook")}
                    error={errors.facebook?.message}
                    type="text"
                    placeholder="www.facebook.com"
                    label="Facebook Page Link"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    icon="title"
                    {...register("youtube")}
                    error={errors.youtube?.message}
                    type="text"
                    placeholder="www.youtube.com"
                    label="Youtube Page Link"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    icon="title"
                    {...register("whatsapps")}
                    error={errors.whatsapps?.message}
                    type="text"
                    placeholder="011234567890"
                    label="WhatsApp Number"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    icon="title"
                    {...register("twitter")}
                    error={errors.twitter?.message}
                    type="text"
                    placeholder="www.twitter.com"
                    label="Twitter Link"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    icon="title"
                    {...register("instagram")}
                    error={errors.instagram?.message}
                    type="text"
                    placeholder="www.instagram.com"
                    label="Instagram Link"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    icon="title"
                    {...register("linkedIn")}
                    error={errors.linkedIn?.message}
                    type="text"
                    placeholder="www.linkedin.com"
                    label="LinkedIn Link"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    icon="title"
                    {...register("googleNews")}
                    error={errors.googleNews?.message}
                    type="text"
                    placeholder="www.news.google.com"
                    label="Google News"
                  />
                </div>
              </div>
            </div>

            {/* Download Links */}
            <div className="section-card">
              <div className="section-header">
                <div className="section-icon">📱</div>
                <h2 className="section-title">App Download Links</h2>
              </div>
              <div className="row g-3">
                <div className="col-md-6">
                  <Input
                    icon="title"
                    {...register("playStore")}
                    error={errors.playStore?.message}
                    type="text"
                    placeholder="www.play.google.com/"
                    label="Play Store"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    icon="title"
                    {...register("appsStore")}
                    error={errors.appsStore?.message}
                    type="text"
                    placeholder="www.apple.com/app-store/"
                    label="App Store"
                  />
                </div>
              </div>
            </div>

            {/* SEO Information */}
            <div className="section-card">
              <div className="section-header">
                <div className="section-icon">🔍</div>
                <h2 className="section-title">SEO Information</h2>
              </div>
              <div className="row g-3">
                <div className="col-md-12">
                  <Input
                    icon="title"
                    {...register("websiteTitle")}
                    error={errors.websiteTitle?.message}
                    type="text"
                    placeholder="Website Title"
                    label="Website Title"
                  />
                </div>
                <div className="col-md-12">
                  <Label label="Meta Description" />
                  {/* ✅ Replace ReactQuill with useQuill */}
                  <div className="quill-wrapper">
                    <div ref={quillRef} style={{ minHeight: "150px" }} />
                  </div>
                  {errors.discription && (
                    <p className="text-danger mt-2">
                      {errors.discription.message}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Save Button */}
            <div className="save-button-wrapper">
              <button
                type="submit"
                className="modern-save-btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : (
                  <>💾 Save Changes</>
                )}
              </button>
            </div>
          </div>

          {/* Sidebar */}
          <div className="col-lg-3">
            <div className="sidebar-card">
              <div className="image-card-header">
                <h5 className="image-card-title">🖼️ Website Logo</h5>
              </div>
              <Controller
                name="image"
                control={control}
                defaultValue={null}
                render={({ field }) => (
                  <SmartImageUpload
                    multiple={false}
                    limit={1}
                    files={field.value ? [field.value] : []}
                    onSelectFiles={(url) => {
                      field.onChange(url.data[0].image || "");
                    }}
                  />
                )}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default Form;
